// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lE3p","right":"styles_right__R0NNn"};